module.exports = __webpack_public_path__ + "static/media/whisky-pour--mobile.8c8bc604.gif";